import {Component, inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {faTriangleExclamation, faXmark, faChevronRight, faPlus} from "@fortawesome/free-solid-svg-icons";
import {SystemManagementService} from "../../../data-access/system-management.service";
import {Pagination} from "../../../../exam/feature/exam-submissions/exam-submissions.component";
import {MenuItem} from "../../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

interface Item {
  name: string,
  course_id: number,
  unit_id: number,
  start: Date
  end: Date
  items: MenuItem[]
}
@Component({
    selector: 'course-list',
    templateUrl: './course-list.component.html',
    standalone: false
})
export class CourseListComponent implements OnInit {
  router = inject(Router)
  systemService = inject(SystemManagementService)
  _snackBar = inject(MatSnackBar)
  currentPagination: Pagination = {
    limit: 25,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }
  items: Item[] = []
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'System Management',
    route: 'dashboard/SystemManagement'
  }, {
    text: 'System Lists',
    route: 'dashboard/SystemManagement/courses/config'
  }]

  ngOnInit() {
    this.handleServiceCall()
  }

  handleServiceCall() {
    this.systemService.listCourses(this.currentPagination.limit, this.currentPagination.page).subscribe((response) => {
      if(response.success) {
        this.items = []
        for(let item of response.result.items) {
          this.items.push({
            ...item,
            items: [{
              title: 'Edit',
              route: 'dashboard/SystemManagement/courses/config',
              queryParams: {queryParams: {course_id: item.course_id, unit_id: item.unit_id, name: item.name, start: item.start, end: item.end}}
            }]
          })
        }
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  systemManagementMenu() {
    this.router.navigate(['dashboard/SystemManagement'])
  }

  courseConfig() {
    // TODO add url param for edit
    this.router.navigate(['dashboard/SystemManagement/courses/config'])
  }

  protected readonly faPlus = faPlus;
}
